export default "__VITE_ASSET__Beu7Fwvc__"